<script>
import { onDestroy, tick } from 'svelte';
import { getChannel } from './sendbird';

function getConstrastColor(hue) {
  const GoldenAngle = 137.508;
  return `hsl(${hue * GoldenAngle}, 100%, 50%)`;
}

export let url;

let container;
let loadBar;
let channel;
let sendbird;
let listQuery;
let messages = [];
let text = '';
let channelSubscription;
let activeChannelHandlerId;

let loadingPriorMessages = false;

const StateIdle = 0;
const StateSending = 1;
const StateSent = 2;
let state = StateIdle;

function loadPreviousMessages() {
  if (loadingPriorMessages) return;
  loadingPriorMessages = true;
  
  listQuery.load(async (messageList, error) => {
    loadingPriorMessages = false;

    if (error) {
      return;
    }

    const sh = container.scrollHeight;
    const st = container.scrollTop;
    const firstLoad = sh === 0;
    messages = [...messageList, ...messages];
    await tick()
    const nh = container.scrollHeight;
    container.scrollTop = firstLoad ? nh : nh - sh + st;
  });
}

function onScroll(e) {
  if (container.scrollTop === 0) loadPreviousMessages();
}

function closeChannel() {
  if (channelSubscription) {
    channelSubscription.unsubscribe()
    channelSubscription = undefined;

    sendbird.removeChannelHandler(activeChannelHandlerId)
  }
}

function setChannel(url) {
  closeChannel();

  channelSubscription = getChannel(url).subscribe(data => {
    if (!data) {
      messages = []
      return;
    }

    channel = data.channel;
    sendbird = data.sendbird;

    listQuery = channel.createPreviousMessageListQuery();
    listQuery.limit = 30;
    listQuery.reverse = false; // latest last, oldest first

    const channelHandler = new sendbird.ChannelHandler();
    channelHandler.onMessageReceived = function(_channel, message) {
      if (_channel === channel) addMessages([message])
    };
    channelHandler.onMessageDeleted = function(_channel, messageId) {
      if (_channel === channel) messages = messages.filter(m => m.messageId !== messageId);
    };

    activeChannelHandlerId = 'OpenChatRoom::' + url;
    sendbird.addChannelHandler(activeChannelHandlerId, channelHandler);
    
    loadPreviousMessages();
  });
}

onDestroy(() => closeChannel())

async function addMessages(msgs) {
  messages = [...messages, ...msgs];
  await tick()
  container.scrollTop = container.scrollHeight;
}

function sendMessage() {
  const val = text.trim();
  if (val.length === 0) return;

  state = StateSending;

  text = ''

  const params = new sendbird.UserMessageParams();
  params.message = val;
  params.pushNotificationDeliveryOption = 'suppress';
  channel.sendUserMessage(params, async (userMessage, error) => {
    if (error) {
      return;
    }
    state = StateSent;
    addMessages([userMessage])
  });
}

function deleteMessage(msg) {
  channel.deleteMessage(msg, (response, error) => {
    if (error) {
      // Handle error.
      return;
    }

    messages = messages.filter(m => m !== msg);
  });
}

$: setChannel(url);
</script>

<div class="container flex-1">
  <div class="col abs">
    <div class="messages flex-1" bind:this={container} on:scroll={onScroll}>
      {#if loadingPriorMessages}
        <div>Loading</div>
      {/if}
      {#each messages as msg(msg.messageId)}
      <!-- on:click={() => deleteMessage(msg)} -->
        <div>
          <!-- {new Date(msg.createdAt).toLocaleTimeString()}  -->
          <span class="name">{msg.sender?.nickname || 'Admin'}</span> {msg.message}
        </div>
      {/each}
    </div>
    <div class="row bottombar vcenter">
      <input class="text-input flex-1" type="text" autocomplete="off" placeholder="Send a message" bind:value={text} on:keydown={e => {
        if (e.key === 'Enter') {
          e.preventDefault();
          sendMessage()
        }
      }} />
      <span class="send-button material-icons" on:click={sendMessage}>send</span>
    </div>
  </div>
</div>

<style>
.container {
  position: relative;
}

.abs {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}
.messages {
  overflow-x: hidden;
  overflow-y: scroll;
  /* height: 100%; */
  width: 100%;
  padding: 4px;
}
.name {
  font-weight: 600;
}

.bottombar {
  background-color: white;
}

.text-input {
  border: none;
}

.send-button {
  padding: 12px;
}
</style>